export class EmployeeData {
  agentContractAmount: number;
  depositAmount: number;
  group: number;
  organizationDto: any;
  organizationId: number;
  rating: number;
  saleAmount: number;
}
